/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onMessageByChatID = /* GraphQL */ `
  subscription OnMessageByChatID($chatID: String!) {
    onMessageByChatID(chatID: $chatID) {
      id
      ownerAccounts
      chatID
      createdAt
      profile
      body
      attachments {
        items {
          id
          ownerAccounts
          messageID
          body
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onSkillTemplateById = /* GraphQL */ `
  subscription OnSkillTemplateById($id: String!) {
    onSkillTemplateById(id: $id) {
      id
      parent
      creator
      name
      instrument
      category
      description
      tutorialVideos
      externalVideos
      supportingDocuments
      instances {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isDeleted
      isShared
      history
      createdAt
      updatedAt
    }
  }
`;
export const onSkillInstanceById = /* GraphQL */ `
  subscription OnSkillInstanceById($id: String!) {
    onSkillInstanceById(id: $id) {
      id
      owner
      profileID
      templateID
      template {
        id
        parent
        creator
        name
        instrument
        category
        description
        tutorialVideos
        externalVideos
        supportingDocuments
        instances {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isDeleted
        isShared
        history
        createdAt
        updatedAt
      }
      createdAt
      percentage
      points
      isDeleted
      isInactive
      isCompleted
      personalTutorialVideos
      responseVideos
      notes
      history
      updatedAt
    }
  }
`;
export const onCreateChat = /* GraphQL */ `
  subscription OnCreateChat {
    onCreateChat {
      id
      ownerAccounts
      topic
      messages {
        items {
          id
          ownerAccounts
          chatID
          createdAt
          profile
          body
          attachments {
            items {
              id
              ownerAccounts
              messageID
              body
              createdAt
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChat = /* GraphQL */ `
  subscription OnUpdateChat {
    onUpdateChat {
      id
      ownerAccounts
      topic
      messages {
        items {
          id
          ownerAccounts
          chatID
          createdAt
          profile
          body
          attachments {
            items {
              id
              ownerAccounts
              messageID
              body
              createdAt
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChat = /* GraphQL */ `
  subscription OnDeleteChat {
    onDeleteChat {
      id
      ownerAccounts
      topic
      messages {
        items {
          id
          ownerAccounts
          chatID
          createdAt
          profile
          body
          attachments {
            items {
              id
              ownerAccounts
              messageID
              body
              createdAt
              updatedAt
            }
            nextToken
          }
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {
      id
      ownerAccounts
      chatID
      createdAt
      profile
      body
      attachments {
        items {
          id
          ownerAccounts
          messageID
          body
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage {
    onUpdateMessage {
      id
      ownerAccounts
      chatID
      createdAt
      profile
      body
      attachments {
        items {
          id
          ownerAccounts
          messageID
          body
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {
      id
      ownerAccounts
      chatID
      createdAt
      profile
      body
      attachments {
        items {
          id
          ownerAccounts
          messageID
          body
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onCreateChatAttachment = /* GraphQL */ `
  subscription OnCreateChatAttachment {
    onCreateChatAttachment {
      id
      ownerAccounts
      messageID
      body
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateChatAttachment = /* GraphQL */ `
  subscription OnUpdateChatAttachment {
    onUpdateChatAttachment {
      id
      ownerAccounts
      messageID
      body
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteChatAttachment = /* GraphQL */ `
  subscription OnDeleteChatAttachment {
    onDeleteChatAttachment {
      id
      ownerAccounts
      messageID
      body
      createdAt
      updatedAt
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation {
    onCreateLocation {
      id
      tag
      label
      address
      phone
      calendarsByInstrument
      consultCalendar
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation {
    onUpdateLocation {
      id
      tag
      label
      address
      phone
      calendarsByInstrument
      consultCalendar
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation {
    onDeleteLocation {
      id
      tag
      label
      address
      phone
      calendarsByInstrument
      consultCalendar
      createdAt
      updatedAt
    }
  }
`;
export const onCreateInstrument = /* GraphQL */ `
  subscription OnCreateInstrument {
    onCreateInstrument {
      id
      tag
      label
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateInstrument = /* GraphQL */ `
  subscription OnUpdateInstrument {
    onUpdateInstrument {
      id
      tag
      label
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteInstrument = /* GraphQL */ `
  subscription OnDeleteInstrument {
    onDeleteInstrument {
      id
      tag
      label
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSetting = /* GraphQL */ `
  subscription OnCreateSetting {
    onCreateSetting {
      id
      name
      value
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSetting = /* GraphQL */ `
  subscription OnUpdateSetting {
    onUpdateSetting {
      id
      name
      value
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSetting = /* GraphQL */ `
  subscription OnDeleteSetting {
    onDeleteSetting {
      id
      name
      value
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSkillTemplate = /* GraphQL */ `
  subscription OnCreateSkillTemplate {
    onCreateSkillTemplate {
      id
      parent
      creator
      name
      instrument
      category
      description
      tutorialVideos
      externalVideos
      supportingDocuments
      instances {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isDeleted
      isShared
      history
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSkillTemplate = /* GraphQL */ `
  subscription OnUpdateSkillTemplate {
    onUpdateSkillTemplate {
      id
      parent
      creator
      name
      instrument
      category
      description
      tutorialVideos
      externalVideos
      supportingDocuments
      instances {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isDeleted
      isShared
      history
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSkillTemplate = /* GraphQL */ `
  subscription OnDeleteSkillTemplate {
    onDeleteSkillTemplate {
      id
      parent
      creator
      name
      instrument
      category
      description
      tutorialVideos
      externalVideos
      supportingDocuments
      instances {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isDeleted
      isShared
      history
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSkillInstance = /* GraphQL */ `
  subscription OnCreateSkillInstance($owner: String) {
    onCreateSkillInstance(owner: $owner) {
      id
      owner
      profileID
      templateID
      template {
        id
        parent
        creator
        name
        instrument
        category
        description
        tutorialVideos
        externalVideos
        supportingDocuments
        instances {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isDeleted
        isShared
        history
        createdAt
        updatedAt
      }
      createdAt
      percentage
      points
      isDeleted
      isInactive
      isCompleted
      personalTutorialVideos
      responseVideos
      notes
      history
      updatedAt
    }
  }
`;
export const onUpdateSkillInstance = /* GraphQL */ `
  subscription OnUpdateSkillInstance($owner: String) {
    onUpdateSkillInstance(owner: $owner) {
      id
      owner
      profileID
      templateID
      template {
        id
        parent
        creator
        name
        instrument
        category
        description
        tutorialVideos
        externalVideos
        supportingDocuments
        instances {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isDeleted
        isShared
        history
        createdAt
        updatedAt
      }
      createdAt
      percentage
      points
      isDeleted
      isInactive
      isCompleted
      personalTutorialVideos
      responseVideos
      notes
      history
      updatedAt
    }
  }
`;
export const onDeleteSkillInstance = /* GraphQL */ `
  subscription OnDeleteSkillInstance($owner: String) {
    onDeleteSkillInstance(owner: $owner) {
      id
      owner
      profileID
      templateID
      template {
        id
        parent
        creator
        name
        instrument
        category
        description
        tutorialVideos
        externalVideos
        supportingDocuments
        instances {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isDeleted
        isShared
        history
        createdAt
        updatedAt
      }
      createdAt
      percentage
      points
      isDeleted
      isInactive
      isCompleted
      personalTutorialVideos
      responseVideos
      notes
      history
      updatedAt
    }
  }
`;
export const onCreateAccount = /* GraphQL */ `
  subscription OnCreateAccount($owner: String) {
    onCreateAccount(owner: $owner) {
      id
      owner
      sub
      email
      name
      picture
      roles
      phone
      profiles {
        items {
          id
          owner
          accountID
          account {
            id
            owner
            sub
            email
            name
            picture
            roles
            phone
            profiles {
              nextToken
            }
            isActive
            isDeleted
            org
            createdAt
            updatedAt
            sourcedFrom
          }
          name
          picture
          color
          instrument
          skills {
            items {
              id
              owner
              profileID
              templateID
              createdAt
              percentage
              points
              isDeleted
              isInactive
              isCompleted
              personalTutorialVideos
              responseVideos
              notes
              history
              updatedAt
            }
            nextToken
          }
          isActive
          schedule
          location
          billingPlan
          isDeleted
          info
          termsAccepted
          termsDocument
          watches {
            items {
              id
              watcherID
              targetID
              lastChat
              lastSkill
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
          billCustomerProfileId
          billProrateState
          billRegistrationFeeState
          billPackageTag
          billReferrer
        }
        nextToken
      }
      isActive
      isDeleted
      org
      createdAt
      updatedAt
      sourcedFrom
    }
  }
`;
export const onUpdateAccount = /* GraphQL */ `
  subscription OnUpdateAccount($owner: String) {
    onUpdateAccount(owner: $owner) {
      id
      owner
      sub
      email
      name
      picture
      roles
      phone
      profiles {
        items {
          id
          owner
          accountID
          account {
            id
            owner
            sub
            email
            name
            picture
            roles
            phone
            profiles {
              nextToken
            }
            isActive
            isDeleted
            org
            createdAt
            updatedAt
            sourcedFrom
          }
          name
          picture
          color
          instrument
          skills {
            items {
              id
              owner
              profileID
              templateID
              createdAt
              percentage
              points
              isDeleted
              isInactive
              isCompleted
              personalTutorialVideos
              responseVideos
              notes
              history
              updatedAt
            }
            nextToken
          }
          isActive
          schedule
          location
          billingPlan
          isDeleted
          info
          termsAccepted
          termsDocument
          watches {
            items {
              id
              watcherID
              targetID
              lastChat
              lastSkill
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
          billCustomerProfileId
          billProrateState
          billRegistrationFeeState
          billPackageTag
          billReferrer
        }
        nextToken
      }
      isActive
      isDeleted
      org
      createdAt
      updatedAt
      sourcedFrom
    }
  }
`;
export const onDeleteAccount = /* GraphQL */ `
  subscription OnDeleteAccount($owner: String) {
    onDeleteAccount(owner: $owner) {
      id
      owner
      sub
      email
      name
      picture
      roles
      phone
      profiles {
        items {
          id
          owner
          accountID
          account {
            id
            owner
            sub
            email
            name
            picture
            roles
            phone
            profiles {
              nextToken
            }
            isActive
            isDeleted
            org
            createdAt
            updatedAt
            sourcedFrom
          }
          name
          picture
          color
          instrument
          skills {
            items {
              id
              owner
              profileID
              templateID
              createdAt
              percentage
              points
              isDeleted
              isInactive
              isCompleted
              personalTutorialVideos
              responseVideos
              notes
              history
              updatedAt
            }
            nextToken
          }
          isActive
          schedule
          location
          billingPlan
          isDeleted
          info
          termsAccepted
          termsDocument
          watches {
            items {
              id
              watcherID
              targetID
              lastChat
              lastSkill
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          createdAt
          updatedAt
          billCustomerProfileId
          billProrateState
          billRegistrationFeeState
          billPackageTag
          billReferrer
        }
        nextToken
      }
      isActive
      isDeleted
      org
      createdAt
      updatedAt
      sourcedFrom
    }
  }
`;
export const onCreateProfile = /* GraphQL */ `
  subscription OnCreateProfile($owner: String) {
    onCreateProfile(owner: $owner) {
      id
      owner
      accountID
      account {
        id
        owner
        sub
        email
        name
        picture
        roles
        phone
        profiles {
          items {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          nextToken
        }
        isActive
        isDeleted
        org
        createdAt
        updatedAt
        sourcedFrom
      }
      name
      picture
      color
      instrument
      skills {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isActive
      schedule
      location
      billingPlan
      isDeleted
      info
      termsAccepted
      termsDocument
      watches {
        items {
          id
          watcherID
          watcherProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          targetID
          targetProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          lastChat
          lastSkill
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      billCustomerProfileId
      billProrateState
      billRegistrationFeeState
      billPackageTag
      billReferrer
    }
  }
`;
export const onUpdateProfile = /* GraphQL */ `
  subscription OnUpdateProfile($owner: String) {
    onUpdateProfile(owner: $owner) {
      id
      owner
      accountID
      account {
        id
        owner
        sub
        email
        name
        picture
        roles
        phone
        profiles {
          items {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          nextToken
        }
        isActive
        isDeleted
        org
        createdAt
        updatedAt
        sourcedFrom
      }
      name
      picture
      color
      instrument
      skills {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isActive
      schedule
      location
      billingPlan
      isDeleted
      info
      termsAccepted
      termsDocument
      watches {
        items {
          id
          watcherID
          watcherProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          targetID
          targetProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          lastChat
          lastSkill
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      billCustomerProfileId
      billProrateState
      billRegistrationFeeState
      billPackageTag
      billReferrer
    }
  }
`;
export const onDeleteProfile = /* GraphQL */ `
  subscription OnDeleteProfile($owner: String) {
    onDeleteProfile(owner: $owner) {
      id
      owner
      accountID
      account {
        id
        owner
        sub
        email
        name
        picture
        roles
        phone
        profiles {
          items {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          nextToken
        }
        isActive
        isDeleted
        org
        createdAt
        updatedAt
        sourcedFrom
      }
      name
      picture
      color
      instrument
      skills {
        items {
          id
          owner
          profileID
          templateID
          template {
            id
            parent
            creator
            name
            instrument
            category
            description
            tutorialVideos
            externalVideos
            supportingDocuments
            instances {
              nextToken
            }
            isDeleted
            isShared
            history
            createdAt
            updatedAt
          }
          createdAt
          percentage
          points
          isDeleted
          isInactive
          isCompleted
          personalTutorialVideos
          responseVideos
          notes
          history
          updatedAt
        }
        nextToken
      }
      isActive
      schedule
      location
      billingPlan
      isDeleted
      info
      termsAccepted
      termsDocument
      watches {
        items {
          id
          watcherID
          watcherProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          targetID
          targetProfile {
            id
            owner
            accountID
            account {
              id
              owner
              sub
              email
              name
              picture
              roles
              phone
              isActive
              isDeleted
              org
              createdAt
              updatedAt
              sourcedFrom
            }
            name
            picture
            color
            instrument
            skills {
              nextToken
            }
            isActive
            schedule
            location
            billingPlan
            isDeleted
            info
            termsAccepted
            termsDocument
            watches {
              nextToken
            }
            createdAt
            updatedAt
            billCustomerProfileId
            billProrateState
            billRegistrationFeeState
            billPackageTag
            billReferrer
          }
          lastChat
          lastSkill
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      billCustomerProfileId
      billProrateState
      billRegistrationFeeState
      billPackageTag
      billReferrer
    }
  }
`;
export const onCreateProfileWatch = /* GraphQL */ `
  subscription OnCreateProfileWatch($owner: String) {
    onCreateProfileWatch(owner: $owner) {
      id
      watcherID
      watcherProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      targetID
      targetProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      lastChat
      lastSkill
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateProfileWatch = /* GraphQL */ `
  subscription OnUpdateProfileWatch($owner: String) {
    onUpdateProfileWatch(owner: $owner) {
      id
      watcherID
      watcherProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      targetID
      targetProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      lastChat
      lastSkill
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteProfileWatch = /* GraphQL */ `
  subscription OnDeleteProfileWatch($owner: String) {
    onDeleteProfileWatch(owner: $owner) {
      id
      watcherID
      watcherProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      targetID
      targetProfile {
        id
        owner
        accountID
        account {
          id
          owner
          sub
          email
          name
          picture
          roles
          phone
          profiles {
            items {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            nextToken
          }
          isActive
          isDeleted
          org
          createdAt
          updatedAt
          sourcedFrom
        }
        name
        picture
        color
        instrument
        skills {
          items {
            id
            owner
            profileID
            templateID
            template {
              id
              parent
              creator
              name
              instrument
              category
              description
              tutorialVideos
              externalVideos
              supportingDocuments
              isDeleted
              isShared
              history
              createdAt
              updatedAt
            }
            createdAt
            percentage
            points
            isDeleted
            isInactive
            isCompleted
            personalTutorialVideos
            responseVideos
            notes
            history
            updatedAt
          }
          nextToken
        }
        isActive
        schedule
        location
        billingPlan
        isDeleted
        info
        termsAccepted
        termsDocument
        watches {
          items {
            id
            watcherID
            watcherProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            targetID
            targetProfile {
              id
              owner
              accountID
              name
              picture
              color
              instrument
              isActive
              schedule
              location
              billingPlan
              isDeleted
              info
              termsAccepted
              termsDocument
              createdAt
              updatedAt
              billCustomerProfileId
              billProrateState
              billRegistrationFeeState
              billPackageTag
              billReferrer
            }
            lastChat
            lastSkill
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        createdAt
        updatedAt
        billCustomerProfileId
        billProrateState
        billRegistrationFeeState
        billPackageTag
        billReferrer
      }
      lastChat
      lastSkill
      createdAt
      updatedAt
      owner
    }
  }
`;
